import React from 'react';
import Navbar from './Navbar';

const Header: React.FC = () => {
  return (
    <Navbar />
  );
};

export default Header;
